import {Component} from 'react';
import PropTypes from 'prop-types';
import EditableTitle from './EditableTitle';
import {Segment} from 'semantic-ui-react';
import PdfReport from './PdfReport';
import Spinner from './Spinner';

export default class CustomiseCustomSection extends Component {
  static propTypes = {
    reportType: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    updateSectionValue: PropTypes.func.isRequired,
    updatePreferences: PropTypes.func.isRequired,
  };

  updateReportTitle = (data) => {
    const {reportType, url, updateSectionValue, updatePreferences} = this.props;

    updateSectionValue(data.title, 'uiLabel');

    let preference = {};
    preference[`custom[${url}].uiLabel`] = data.title;
    updatePreferences(preference, reportType);
  };

  onPdfError = () => this.props.updateSectionValue(true, 'hasError');

  render() {
    const {title, url} = this.props;
    const loading = (
      <div style={{fontSize: '0.8em', height: '294px', width: '200px', margin: 'auto', marginTop: '20px'}}>
        <Spinner/>
      </div>
    );

    return (
      <div className="custom-section">
        <EditableTitle level="h2"
                       className="section-type"
                       onUpdateData={this.updateReportTitle}
                       title={title}
                       isEnabled={true}
                       maxLength={20}
        />
        <Segment style={{padding: '30px'}}>
          <Segment color="grey" compact style={{
            display: 'block',
            border: '1px solid #bebebe',
            maxWidth: '210px',
            padding: '0.3em',
          }}>
            <PdfReport loading={loading} maxPages={1} url={url} width={200} onPdfError={this.onPdfError} />
          </Segment>
        </Segment>
      </div>
    );
  }
}